import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem('certifyai_token');
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem('certifyai_token');
            localStorage.removeItem('certifyai_user');
            const path = window.location.pathname;
            // Skip redirect on public/auth pages so we don't loop
            if (!path.startsWith('/login') && !path.startsWith('/register') && path !== '/') {
                // Detect if we're in the standalone PWA (Auditor App)
                const isStandalone = (
                    (typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches) ||
                    window.navigator.standalone === true
                );
                // If we're already inside the Auditor App flow, send back to /app,
                // otherwise fall back to the unified login page.
                const target = (isStandalone || path === '/app' || path.startsWith('/inspector')) ? '/app' : '/login';
                if (path !== target) {
                    window.location.href = target;
                }
            }
        }
        return Promise.reject(err);
    }
);

/**
 * Extrae un mensaje legible (string) de cualquier error de axios.
 * Maneja: 422 Pydantic v2 (Array<{loc,msg,type,input,url}>), 400/500 con string,
 * objetos arbitrarios, y errores de red.
 */
export function apiErrorMessage(err, fallback = 'Ocurrió un error') {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || fallback;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
        return detail.map((d) => {
            if (typeof d === 'string') return d;
            const field = Array.isArray(d?.loc) ? d.loc.slice(-1)[0] : '';
            return [field, d?.msg].filter(Boolean).join(': ');
        }).filter(Boolean).join(' • ') || fallback;
    }
    if (typeof detail === 'object') {
        return detail.msg || detail.message || JSON.stringify(detail);
    }
    return fallback;
}

export default api;
